/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshPaychecksApplet} from '../api'

export const useMutationRefreshPaychecksApplet = createReactQueryMutationHook('refreshPaychecksApplet', refreshPaychecksApplet)
